import React from "react";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { MoveHorizontal } from "lucide-react";
import { resolveImg } from "@/lib/api";

// Touch-friendly draggable before/after comparison.
export default function BeforeAfterSlider({ prima, dopo, altPrima = "Prima", altDopo = "Dopo", testId = "before-after-slider" }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-av-black" data-testid={testId}>
      <ReactCompareSlider
        className="aspect-[4/3] sm:aspect-[16/10] w-full"
        handle={
          <div className="flex flex-col items-center justify-center h-full">
            <div className="w-[3px] flex-1 bg-white/80" />
            <div className="w-12 h-12 rounded-full bg-av-bright text-av-black flex items-center justify-center shadow-lg shrink-0">
              <MoveHorizontal size={20} strokeWidth={2.5} />
            </div>
            <div className="w-[3px] flex-1 bg-white/80" />
          </div>
        }
        itemOne={<ReactCompareSliderImage src={resolveImg(prima)} alt={altPrima} loading="lazy" />}
        itemTwo={<ReactCompareSliderImage src={resolveImg(dopo)} alt={altDopo} loading="lazy" />}
      />
      <span className="pointer-events-none absolute top-3 left-3 z-10 rounded-full bg-av-black/70 backdrop-blur px-3 py-1 text-[11px] font-semibold tracking-widest uppercase text-av-white">Prima</span>
      <span className="pointer-events-none absolute top-3 right-3 z-10 rounded-full bg-av-bright/90 px-3 py-1 text-[11px] font-semibold tracking-widest uppercase text-av-black">Dopo</span>
    </div>
  );
}
